export default __webpack_public_path__ + "static/media/normal_day.5af6b111.png";